import moment from 'moment';
import { useState } from 'react';
import { styledDefaultColDef } from '../../../extras/cellRenderers';
import CustomCohortFilter from './customCohortFilter';
import CustomRecordingFilter from './customRecordingFilter';
import CustomHandoutFilter from './customHandoutFilter';
// import LogsModal from './LogsModal';
import RecordingLink from './recordingLink';
import uploadIcon from './uploadLink.svg';
import HandoutModal from './HandoutModal';
import ConfirmationModal from './ConfirmationModal';

const Recording = (params, refreshData, activeTab) => {
  const [showModal, setShowModal] = useState(false);
  const disabled = moment(params.data.endTime) > moment();
  const videoItemKey =
    params.data?.classActivityRecording?.videoItemKeyV2?.itemKey ??
    params.data?.classActivityRecording?.videoItemKey;
  const isRecordingLinkAvailable = () => {
    if (params.data?.classActivityRecording === null) {
      return false;
    } else if (videoItemKey === null) {
      return false;
    } else if (videoItemKey.length === 0) {
      return false;
    }
    return true;
  };
  const recordingLinkAvail = isRecordingLinkAvailable();
  return (
    <div className='flex items-center h-full'>
      {showModal && (
        <RecordingLink
          showModal={showModal}
          setShowModal={setShowModal}
          data={params.data}
          refreshData={refreshData}
          recordingLinkAvail={recordingLinkAvail}
          activeTab={activeTab}
        />
      )}

      {params?.data?.sessionType === 'Live' && (
        <>
          {!recordingLinkAvail ? (
            <div
              className={`flex gap-2 text-sm items-center cursor-pointer ${
                disabled ? 'pointer-events-none' : ''
              }`}
              onClick={() => setShowModal(true)}
            >
              <img src={uploadIcon} />
              <span
                className='text-medium'
                style={{ color: disabled ? 'gray' : '#1C5DDB' }}
              >
                Upload
              </span>
            </div>
          ) : (
            <span
              className='text-medium cursor-pointer'
              style={{ color: '#1C5DDB' }}
              onClick={() => setShowModal(true)}
            >
              Update Recording
            </span>
          )}
        </>
      )}
      {params?.data?.sessionType !== 'Live' && (
        <span className='text-medium' style={{ color: '#1C5DDB' }}>
          N/A
        </span>
      )}
    </div>
  );
};

const IncludeInLibrary = ({ params, refreshData }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  console.log(selectedValue);

  const handleCheckboxClick = (value) => {
    setSelectedValue(value);
    setShowModal(true);
  };



  return (
    <div>
      <input
        type="checkbox"
        checked={params.data.includeInLibrary}
        onChange={() => handleCheckboxClick(!params.data.includeInLibrary)}
      />
      {showModal && (
        <ConfirmationModal
          message="Are you sure you want to include in library?"
          showModal={showModal}
          setShowModal={setShowModal}
          params = {params}
          type='LSS'
          refreshData={refreshData}
        />
      )}
    </div>
  );
};

const Handouts = (params, refreshData, activeTab) => {
  const [showModal, setShowModal] = useState(false);
  const disabled = moment(params.data.endTime) > moment();
  const isHandoutLinkAvailable = () => {
    if (params.data?.classActivityRecording === null) {
      return false;
    } else if (params.data?.classActivityRecording?.handout === null) {
      return false;
    } else if (
      params.data?.classActivityRecording?.handout?.link.length === 0
    ) {
      return false;
    }
    return true;
  };

  const handoutLinkAvailable = isHandoutLinkAvailable();

  return (
    <div className='flex items-center h-full'>
      {showModal && (
        <HandoutModal
          showModal={showModal}
          setShowModal={setShowModal}
          data={params.data}
          refreshData={refreshData}
          handoutLinkAvailable={!handoutLinkAvailable}
          activeTab={activeTab}
        />
      )}
      {params?.data?.sessionType === 'Live' && (
        <>
          {!handoutLinkAvailable ? (
            <div
              className={`flex gap-2 text-sm items-center cursor-pointer ${
                disabled ? 'pointer-events-none' : ''
              }`}
              onClick={() => setShowModal(true)}
            >
              <img src={uploadIcon} />
              <span
                className='text-medium'
                style={{ color: disabled ? 'gray' : '#1C5DDB' }}
              >
                Upload
              </span>
            </div>
          ) : (
            <span
              className='text-medium cursor-pointer'
              style={{ color: '#1C5DDB' }}
              onClick={() => setShowModal(true)}
            >
              Update Handout
            </span>
          )}
        </>
      )}
      {params?.data?.sessionType !== 'Live' && (
        <span className='text-medium' style={{ color: '#1C5DDB' }}>
          N/A
        </span>
      )}
    </div>
  );
};

// const Logs = (params) => {
//   const [showModal, setShowModal] = useState(false);
//   return (
//     <>
//       {showModal && (
//         <LogsModal
//           showModal={showModal}
//           setShowModal={setShowModal}
//           data={params.data}
//         />
//       )}
//       <p
//         className='text-medium cursor-pointer h-full flex items-center'
//         style={{ color: '#1C5DDB' }}
//         onClick={() => setShowModal(true)}
//       >
//         View
//       </p>
//     </>
//   );
// };

export const columnDefs = (refreshData, activeTab) => {
  
      console.log(refreshData, 'params');

  return [
    // module name
    {
      headerName: 'Activity ID',
      field: 'activityId',
    },
    {
      headerName: 'Event',
      field: 'eventName',
      hide: true,
    },
    {
      headerName: 'Course Type',
      field: 'courseType',
      hide: true,
    },
    {
      headerName: 'Lesson Id',
      field: 'lessonId',
      hide: true,
    },
    {
      headerName: 'Airmeet Session Id',
      field: 'airmeetSessionId',
      hide: true,
    },
    {
      headerName: 'Moderator Email',
      field: 'moderatorEmail',
      hide: true,
      valueGetter: (props) => props.data.moderatorEmail,
    },
    {
      headerName: 'Session Type',
      field: 'sessionType',
      hide: true,
    },
    {
      headerName: 'instructorEmail',
      field: 'instructorEmail',
      hide: true,
    },
    {
      headerName: 'Module  Name',
      field: 'moduleName',
      headerTooltip: 'Module  Name',
      width: 200,
      filter: 'agSetColumnFilter',
      sortable: false,
      valueFormatter: (params) => {
        return params.data.module;
      },
      valueGetter: (props) => props.data.module,
      filterParams: {
        valueGetter: (props) => props.data.module,
        debounceMs: 200,
      },
      cellRenderer: 'moduleGetter',
    },
    // topic name
    {
      headerName: 'Topic  Name',
      field: 'topicName',
      headerTooltip: 'Topic  Name',
      filter: 'agSetColumnFilter',
      sortable: false,
      valueGetter: (props) => props.data.topic,
      valueFormatter: (params) => {
        return params.data.topic;
      },
      filterParams: {
        valueGetter: (props) => props.data.topic,
        debounceMs: 200,
      },
    },
    // created on
    {
      headerName: 'Date',
      field: 'date',
      headerTooltip: 'Date',
      width: 250,
      valueFormatter: (params) => {
        return `${moment(params.data?.startTime).format(
          'ddd, DD MMM YYYY, h:mm a'
        )}`;
      },
      filter: 'agDateColumnFilter',
      valueGetter: (props) => moment(props.data?.startTime),
      filterParams: {
        valueGetter: (props) => moment(props.data?.startTime),
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          const dateAsString = moment(cellValue).format('YYYY-MM-DD');
          const dateParts = dateAsString.split('-');
          const cellDate = new Date(
            Number(dateParts[0]),
            Number(dateParts[1]) - 1,
            Number(dateParts[2])
          );
          if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
            return 0;
          }
          if (cellDate < filterLocalDateAtMidnight) {
            return -1;
          }
          if (cellDate > filterLocalDateAtMidnight) {
            return 1;
          }
          return 0;
        },
        defaultOption: 'lessThan',
        filterOptions: ['lessThan', 'greaterThan', 'inRange'],
      },
      sortable: true,
      comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
        const date1Millis = new Date(nodeA?.data?.startTime).getTime();
        const date2Millis = new Date(nodeB?.data?.startTime).getTime();
        return date1Millis - date2Millis;
      },
    },
    // cohort
    {
      headerName: 'Cohort',
      field: 'cohort',
      headerTooltip: 'Cohort',
      sortable: false,
      filter: CustomCohortFilter,
      filterParams: {
        title: 'Cohort Filter',
        values: [],
      },
      valueFormatter: (params) => {
        return params.data.classEventCohort.cohortName;
      },
      valueGetter: (props) => props.data.classEventCohort.cohortName,
    },
    // instructor name
    {
      headerName: 'Instructor Name',
      field: 'instrutorName',
      headerTooltip: 'Instructor Name',
      filter: 'agSetColumnFilter',
      sortable: false,
      valueFormatter: (params) => {
        return params.data.instructorName;
      },
      filterParams: {
        valueGetter: (props) => props.data.instructorName,
        debounceMs: 200,
      },
      valueGetter: (props) => props.data.instructorName,
    },
    // Moderator Name
    {
      headerName: 'Moderator Name',
      field: 'moderatorName',
      headerTooltip: 'Moderator Name',
      filter: 'agSetColumnFilter',
      sortable: false,
      valueFormatter: (params) => {
        return params.data.moderatorName;
      },
      filterParams: {
        valueGetter: (props) => props.data.moderatorName,
        debounceMs: 200,
      },
      valueGetter: (props) => props.data.moderatorName,
    },
    // Recording
    {
      headerName: 'Recording',
      field: 'recording',
      headerTooltip: 'Recording',
      sortable: false,
      cellRenderer: (params) => Recording(params, refreshData, activeTab),
      filter: CustomRecordingFilter,
      filterParams: {
        title: 'Recording Filter',
        values: ['All', 'Uploaded', 'Not Uploaded'],
      },
      valueFormatter: (params) => {
        return (
          params.data?.classActivityRecording?.videoItemKeyV2?.itemKey ??
          params.data?.classActivityRecording?.videoItemKey
        );
      },
      valueGetter: (props) =>
        props.data?.classActivityRecording?.videoItemKeyV2?.itemKey ??
        props.data?.classActivityRecording?.videoItemKey
          ? 'Uploaded'
          : 'Not Uploaded',
    },
    // Handouts
    {
      headerName: 'Handouts',
      field: 'handouts',
      headerTooltip: 'Handouts',
      sortable: false,
      cellRenderer: (params) => Handouts(params, refreshData, activeTab),
      filter: CustomHandoutFilter,
      filterParams: {
        title: 'Handout Filter',
        values: ['All', 'Uploaded', 'Not Uploaded'],
      },
      valueFormatter: (params) => {
        return params.data?.classActivityRecording?.handout?.link;
      },
      valueGetter: (props) =>
        props.data?.classActivityRecording?.handout?.link
          ? 'Uploaded'
          : 'Not Uploaded',
    },
       {
      headerName: 'Include In Library',
      field: 'includeInLibrary',
      headerTooltip: 'Include In Library',
      sortable: false,
      cellRenderer: (params) => IncludeInLibrary({ params, refreshData }),
      valueGetter: (props) => props.data.includeInLibrary,
    },
    // Logs
    // {
    //   headerName: 'Logs',
    //   field: 'logs',
    //   headerTooltip: 'Logs',
    //   filter: 'agTextColumnFilter',
    //   sortable: false,
    //   cellRenderer: Logs,
    //   valueGetter: () => null,
    // },
  ];
};

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: true,
};
